import { Component, OnInit } from '@angular/core';
import { DsoStoreService } from '@app/dso/services/dso-store.service';
import { UserStoreService } from '@app/shared/services/store/user-store.service';
import { filter, orderBy } from 'lodash';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { map, switchMap } from 'rxjs/operators';
@Component({
  selector: 'app-dso-dropdown',
  templateUrl: './dso-dropdown.component.html',
})
export class DsoDropdownComponent implements OnInit {
  private dsoStore: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  dsos$ = this.dsoStore.pipe(
    switchMap((dsos) => this.userStore.user$.pipe(map((user) => (user.assignedDsoid ? filter(dsos, (d) => d.guid === user.assignedDsoid) : dsos)))),
    map((dsos) =>
      dsos.map((dso) => ({
        displayName: dso.name,
        isDeactivated: dso.isActive,
        ...dso,
      })),
    ),
    map((x) => orderBy(x, ['displayName'], ['asc'])),
  );

  constructor(
    private readonly _store: DsoStoreService,
    protected readonly userStore: UserStoreService,
  ) {}

  ngOnInit() {
    this._store.dso$.subscribe((x) => this.dsoStore.next(x));
  }

  searchTermChanged = (searchTerm: string) => {
    this._store.dso$
      .subscribe((x) => {
        const filteredDso = Object.assign([], x).filter((item: any) => item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1);
        this.dsoStore.next(filteredDso);
      })
      .unsubscribe();
  };

  dsoSelected = (dso: any) => {
    // gets the updated values from MFE dso-store service
    addEventListener('dsoPatched', (event: any) => {
      this._store.updateDso(event.detail);
    });

    this._store.setSelectedDso(dso);
  };
}
